import React, { Component } from 'react';
import { shallowEquals } from '../../../utils/object';
import withLabel from '../Label';
import './text-input.scss';

class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
    };

    this.getRef = this.getRef.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const arePropsEqual = shallowEquals(
      nextProps,
      this.props,
      'disabled',
      'readOnly',
      'value',
      'type',
      'hasError'
    );

    return !arePropsEqual || this.state.active !== nextState.active;
  }

  getRef(input) {
    this.input = input;
    this.props.getRef && this.props.getRef(input);

    if (input && this.props.autoFocus) {
      setTimeout(() => input.focus(), 10);
    }
  }

  handleBlur(event) {
    this.setState({ active: false });
    !!this.props.onBlur && this.props.onBlur(event);
  }

  handleFocus(event) {
    this.setState({ active: true });
    !!this.props.onFocus && this.props.onFocus(event);
  }

  handleClick() {
    this.input && this.input.focus();
  }

  renderInput() {
    const options = {
      id: this.props.id || this.props.name,
      name: this.props.name,
      required: this.props.required,
      onFocus: event => this.handleFocus(event),
      onBlur: event => this.handleBlur(event),
      onKeyUp: event => this.props.onKeyUp && this.props.onKeyUp(event),
      onChange: this.props.onChange,
      disabled: this.props.disabled,
      'aria-description': this.props.aria_description,
      value: this.props.value,
      type: this.props.type,
      readOnly: this.props.readOnly,
      placeholder: this.props.placeholder,
      maxLength: this.props.maxLength,
      minLength: this.props.minLength,
      autoComplete: 'off',
      ref: this.getRef,
      className: !!this.props.className
        ? `text-input ${this.props.className}`
        : 'text-input',
    };

    return <input onClick={this.handleClick.bind(this)} {...options} />;
  }

  render() {
    return this.renderInput();
  }
}

export default withLabel(TextInput);



// WEBPACK FOOTER //
// ./src/components/UI/TextInput/index.js